import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import css from '../assets/css.png';
import git from '../assets/git.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import firebase from '../assets/firebase.png';
import bootstrap from '../assets/bootstrap.png';
import mongodb from '../assets/mongodb.png';
import svelte from '../assets/svelte.png';
import expressjs from '../assets/expressjs.png';
import antd from '../assets/antd.png';
import mongoose from '../assets/mongoose.png';
import reactrouter from '../assets/reactrouter.png';
import ROS from '../assets/ROS.png';
import ubuntu from '../assets/ubuntu.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';

const images = {
    email,
    mobile,
    api,
    css,
    git,
    html,
    javascript,
    mu5,
    node,
    react,
    redux,
    sass,
    about01,
    about02,
    about03,
    about04,
    profile,
    circle,
    logo,
    firebase,
    mongodb,
    bootstrap,
    svelte,
    expressjs,
    antd,
    mongoose,
    reactrouter,
    ROS,
    ubuntu,
};
export default images;